import { useField } from "formik"

//Styles
import myStyles from "../../../../styles/kiosk/KioskAdminFormWizard.module.css"
import { LogError } from "../../../../helpers/logger"

export default function WizardPageFieldsNodeName({ rowData, fields }) {
  const fieldInstance = fields.find(
    (field) =>
      field.blockId === rowData.data.blockId &&
      field.fieldId === rowData.data.fieldId,
  )

  const indexOf = fields.indexOf(fieldInstance || {})

  const [formId] = useField("id")
  const [field] = useField(`fields[${indexOf < 0 ? 0 : indexOf}]`)

  if (!fieldInstance || indexOf < 0) {
    LogError("Unable to find field instance for rowData.data", rowData)
    return <>Unknown field</>
  }

  return (
    <div className={myStyles.fieldTableNameContainer}>
      {rowData.data.hasParent && (
        <span className="material-icons" style={{ color: "#C189CE" }}>
          subdirectory_arrow_right
        </span>
      )}
      <label className={myStyles.fieldNameLabel}>
        {field.value?.fieldLabel}
      </label>
      {formId.value && !field.value?.id && !field.value?.modified && (
        <div className={myStyles.fieldNew}>NEW</div>
      )}
      {field.value?.systemRequired && (
        <>
          <div
            className={`${myStyles.fieldSystem} systemRequiredField`}
            data-pr-tooltip="This field is required by the system and cannot be modified."
            data-pr-position="bottom"
          >
            System
          </div>
        </>
      )}
    </div>
  )
}
